module.exports = __webpack_public_path__ + "img/videoIcon.2b69ecc8.svg";